import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon'

export function MainFooter() {
	const mailingAddress = `Clearwater Farms Property Owners Association, 
Unit #1 (C.F.P.O.A. Unit 1)
PO BOX 597 
Waddell, Arizona 85355`
	return (
		<div className="w-full p-4 lg:p-8">
			<div className="md:flex md:justify-between">
				<div className="mb-6 md:mb-0">
					<div className="flex content-start">
						<Icon className="text-secondary-foreground size-14" name="cwf" />
						<Link
							to="/"
							className="group flex flex-wrap items-center leading-snug"
						>
							<span className="text-lg font-bold transition group-hover:translate-y-1">
								Clearwater Farms&nbsp;
							</span>
							<span className="text-md font-light text-nowrap transition group-hover:-translate-y-1">
								Unit 1
							</span>
						</Link>
					</div>
					<pre>
						<pre>{mailingAddress}</pre>
					</pre>
				</div>
				<div className="grid grid-cols-2 gap-8 sm:gap-6">
					<div>
						<Link to="/contact-us">
							<h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase hover:underline dark:text-white">
								Contact us
							</h2>
						</Link>
						<ul className="font-medium text-gray-500 dark:text-gray-400">
							<li>
								<Icon
									className="mr-1 mb-1 h-6 w-6 text-blue-700"
									name="id-card"
								/>
								<a
									href="mailto:support@clearwaterfarmsunit1.com"
									className="mb-4"
								>
									support@clearwaterfarmsunit1.com
								</a>
							</li>
							<li>
								<Icon
									className="mr-1 mb-1 h-6 w-6 text-blue-700"
									name="mobile"
								/>
								<a href="tel:6237036126">(623) 703-6126</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<hr className="my-6 border-gray-200 sm:mx-auto lg:my-8 dark:border-gray-700" />
			<div className="sm:flex sm:items-center sm:justify-between">
				<span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
					© 2024 Clearwater Farms Unit 1. All Rights Reserved.
				</span>
				<div className="mt-4 flex sm:mt-0 sm:justify-center">
					<a
						href="https://www.facebook.com/groups/182246863357297/"
						className="text-gray-500 hover:text-gray-900 dark:hover:text-white"
					>
						<svg
							className="h-5 w-5"
							aria-hidden="true"
							xmlns="http://www.w3.org/2000/svg"
							fill="#1976D2"
							viewBox="0 0 8 19"
						>
							<path
								fillRule="evenodd"
								d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z"
								clipRule="evenodd"
							/>
						</svg>
						<span className="sr-only">Facebook</span>
					</a>
					<a
						href="https://nextdoor.com/neighborhood/clearwaterfarms--waddell--az"
						className="ms-2 text-gray-500 hover:text-gray-900 dark:hover:text-white"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-5 w-5"
							aria-hidden="true"
							fill="currentColor"
							viewBox="0 0 24 24"
							id="nextdoor"
						>
							<path
								fill="#8BC94D"
								d="M2.5 3.75C2.08579 3.75 1.75 4.08579 1.75 4.5V7.5C1.75 9.84721 3.65279 11.75 6 11.75H6.75V19.5C6.75 19.9142 7.08579 20.25 7.5 20.25H11.5C11.9142 20.25 12.25 19.9142 12.25 19.5V11.5C12.25 10.2574 13.2574 9.25 14.5 9.25C15.7426 9.25 16.75 10.2574 16.75 11.5V19.5C16.75 19.9142 17.0858 20.25 17.5 20.25H21.5C21.9142 20.25 22.25 19.9142 22.25 19.5V11.5C22.25 7.21979 18.7802 3.75 14.5 3.75C11.7881 3.75 9.40238 5.14326 8.01833 7.25H8C7.58579 7.25 7.25 6.91421 7.25 6.5V4.5C7.25 4.08579 6.91421 3.75 6.5 3.75H2.5Z"
							></path>
						</svg>
						<span className="sr-only">Nextdoor</span>
					</a>
				</div>
			</div>
		</div>
	)
}
